module.exports = __webpack_public_path__ + "idea_icon.png?b83f358659dc07a13c6adf6337daa6f8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-icons/idea_icon.png
// module id = 10
// module chunks = 0